import { useCallback, useEffect, useRef } from 'react'

/*
costum hook to handle click outside of a component
 to close the component
 */
const useClickOutside = (callbackFnc: () => void) => {
  const ref = useRef<HTMLDivElement>(null)

  const eventHandler = useCallback(
    (event: MouseEvent) => {
      // do not react to clicks on the component or its children
      if (!ref.current?.contains(event.target as Node)) {
        callbackFnc()
      }
    },
    [callbackFnc]
  )

  useEffect(() => {
    const node = ref.current

    if (node) {
      document.addEventListener('mousedown', eventHandler)

      return () => {
        document.removeEventListener('mousedown', eventHandler)
      }
    }
  }, [eventHandler])

  return ref
}

export default useClickOutside
